
import React, { useEffect } from 'react';

const SessionContext = React.createContext(null);
export const useSessionContext = () => React.useContext(SessionContext);


function Wait() { 
    return <p>Loading...</p>;
}

/**
* Will only allow content to show if there is a user session
* usage: 
<SessionContextProvider authenticator={authenticator} onSessionLoaded={onSessionLoaded} >
<MainScreen />
</SessionContextProvider>

authenticator = { loadSession(), signOut(),  signIn(username, password) }
onSessionLoaded = (loadedSessionData) => { ... }
*/
export function SessionContextProvider(props) {
    
    const { authenticator, onSessionLoaded, noSessionContent } = props;
    
    const [isAuthenticated, userHasAuthenticated] = React.useState(false);
    const [isOffline, setIsOffline] = React.useState(false);
    const [isAuthenticating, setIsAuthenticating] = React.useState(true);
    const [user, setUser] = React.useState(null);
    
    useEffect(() => { onLoadSession() }, []);
    
    async function onLoadSession() {
        // check with backend
        if (isAuthenticated) return;
        try {
            setIsAuthenticating(true);
            console.log("loading session user")
            const aUser = await authenticator.loadUserFromBackend();
            if (aUser != null) {
                setUser(aUser); // then set the user, 
                userHasAuthenticated(true); // lastly, flag that user has authenticated
            } else { 
                setUser(null);     
            }
        } catch (e) {
            console.error(e);
        }
        setIsAuthenticating(false);
    }
    
    function setOffline(offline) {
        setIsOffline(offline);
        if (offline) {
            setUser( { name: 'Offline user', email: 'offline@domain.com'});
            userHasAuthenticated(true);
        } 
    }
    
    function logout() {
        authenticator.signOut();
        setUser(null);
        setOffline(false); // signing out should always enable online mode
        userHasAuthenticated(false);
    }
    
    async function signUp(email, password, payload) {
        setIsAuthenticating(true);
        const result = await authenticator.signUp(email, password, payload);
        //console.log("signup result", result)
        if (result) { 
            setUser(result);
            userHasAuthenticated(true);    
        } else { 
            setUser(null);
        }
        setIsAuthenticating(false);
        
    }
    
    async function authenticate(username, password) {
        setIsAuthenticating(true);
        //console.log("authing with ", username, password);
        const aUser = await authenticator.signIn(username, password);
        //console.log("User is", aUser)
        setUser(aUser)
        userHasAuthenticated(aUser != null);
        setIsAuthenticating(false);
        if (aUser != null) onLoadSession(); // load campaign    
        return aUser;
    }
    
    //console.log("Auth check on client side ", { isAuthenticated, isAuthenticating } )
    return (
        <SessionContext.Provider value={{ isAuthenticated, isOffline, isAuthenticating, userHasAuthenticated, user, setUser, setOffline, logout, authenticate, signUp }} >
        { 
            (isAuthenticated || isOffline ) ? props.children : (isAuthenticating ? <Wait/> : noSessionContent )
        }
        </SessionContext.Provider>
    )
}

